import { gql } from '@/__generated__';

const GET_DGA_CONFIGURATION_SCHEDULE = gql(`#graphql
  query GetDGAConfigurationSchedule($deviceInput: DeviceInput!) {
    device(input: $deviceInput) {
      id
      dga {
        id
        configuration {
          id
          frequency
          hour
          weekday
          day
          enabled
          dataDelayInHours
          startTimestamp
        }
      }
    }
  }
`);

export default GET_DGA_CONFIGURATION_SCHEDULE;
